import React from 'react'
import PropTypes from 'prop-types'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'

function EdgeLabel ({ label, format, x, y }) {
  const { formatter } = useFormattingContext()

  const displayLabel = format
    ? formatter(label, format)
    : label

  return (
    <div
      className='nodrag nopan'
      style={{
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
        background: '#FFFFFF',
        padding: '4px 10px',
        borderRadius: 4,
        fontSize: 12,
        fontWeight: 600,
        color: 'var(--text-primary)',
        pointerEvents: 'none',
        whiteSpace: 'nowrap'
      }}
    >
      {displayLabel}
    </div>
  )
}

EdgeLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  format: PropTypes.string,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
}

export default EdgeLabel
